import { render, staticRenderFns } from "./m_gift.vue?vue&type=template&id=b1a2e20a&scoped=true&"
import script from "./m_gift.vue?vue&type=script&lang=js&"
export * from "./m_gift.vue?vue&type=script&lang=js&"
import style0 from "./m_gift.vue?vue&type=style&index=0&id=b1a2e20a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1a2e20a",
  null
  
)

export default component.exports